import { render, staticRenderFns } from "./DownloadFiles.vue?vue&type=template&id=342f43cb&"
import script from "./DownloadFiles.vue?vue&type=script&lang=js&"
export * from "./DownloadFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports